module.exports = __webpack_public_path__ + "img/main_media_slide8.55bbb88f.jpg";